// Story blocks client — lists the tenant's PUBLISHED web stories so they can be
// embedded in an email. Normalizes each story to what the email Story block needs:
// a poster, a live URL, and per-page slide images (for the AMP-email carousel).
import axios from 'axios'

function authHeaders() {
  return {
    'x-access-token': localStorage.getItem('user') || localStorage.getItem('customer-portal'),
    'x-api-key': localStorage.getItem('api-key'),
  }
}

// Turn a raw story doc into the fields the Story block stores/renders.
export function normalizeStory(s) {
  const meta = s.storyMetadata || {}
  const pages = Array.isArray(s.pages) ? s.pages : []
  const slides = pages
    .map(pg => ({ img: pg.thumbnail || pg.background?.mediaSrc || '', alt: pg.name || s.title || 'Story slide' }))
    .filter(sl => sl.img)
  const poster = meta.cfThumbnailUrl || slides[0]?.img || ''
  const url = meta.publishedUrl || meta.cloudflareUrl || meta.localPublishedUrl || ''
  return {
    id: s.id || s._id,
    title: s.title || 'Untitled Story',
    publisherName: s.publisherName || '',
    poster,
    url,
    slides,
    slideCount: slides.length,
  }
}

export async function listPublishedStories() {
  const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/stories?status=published`, { headers: authHeaders() })
  const items = res?.data?.data || []
  return items.map(normalizeStory)
}
